import { z } from 'zod';
/** How a feed receives its rows: pushed by an EHR, or pulled by a list job primary schedules. */
export var FeedKind;
(function (FeedKind) {
    FeedKind["EhrPush"] = "EHR_PUSH";
    FeedKind["SyncList"] = "SYNC_LIST";
})(FeedKind || (FeedKind = {}));
export const FeedKindSchema = z.enum(FeedKind);
/** How a pushed feed reaches us. Only SFTP today. */
export var FeedConnectionMethod;
(function (FeedConnectionMethod) {
    FeedConnectionMethod["Sftp"] = "Sftp";
})(FeedConnectionMethod || (FeedConnectionMethod = {}));
export const FeedConnectionMethodSchema = z.enum(FeedConnectionMethod);
//# sourceMappingURL=kind.js.map